/**
 * Mobile menu functionality for the Lastag theme.
 *
 * @package Lastag
 * @version 1.0.0
 */

export function initializeMobileMenu() {
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    const navigationWrapper = document.querySelector('.navigation-wrapper');
    const body = document.body;

    if (!mobileToggle || !navigationWrapper) {
        return;
    }

    mobileToggle.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isOpen = this.classList.contains('active');
        
        if (isOpen) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            if (window.innerWidth <= 768) {
                closeMobileMenu();
            }
        });
    });

    document.addEventListener('click', function(e) {
        if (!e.target.closest('.main-navigation') && mobileToggle.classList.contains('active')) {
            closeMobileMenu();
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileToggle.classList.contains('active')) {
            closeMobileMenu();
            mobileToggle.focus();
        }
    });

    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && mobileToggle.classList.contains('active')) {
            closeMobileMenu();
        }
    });

    function openMobileMenu() {
        mobileToggle.classList.add('active');
        mobileToggle.setAttribute('aria-expanded', 'true');
        navigationWrapper.classList.add('mobile-menu-open');
        body.classList.add('mobile-menu-active');
        
        const firstNavLink = navigationWrapper.querySelector('.nav-link');
        if (firstNavLink) {
            firstNavLink.focus();
        }
    }

    function closeMobileMenu() {
        mobileToggle.classList.remove('active');
        mobileToggle.setAttribute('aria-expanded', 'false');
        navigationWrapper.classList.remove('mobile-menu-open');
        body.classList.remove('mobile-menu-active');
    }

    navigationWrapper.addEventListener('keydown', function(e) {
        if (!e.target.classList.contains('nav-link')) {
            return;
        }

        const navLinks = Array.from(navigationWrapper.querySelectorAll('.nav-link'));
        const currentIndex = navLinks.indexOf(e.target);
        
        switch(e.key) {
            case 'ArrowDown':
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % navLinks.length;
                navLinks[nextIndex].focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                const prevIndex = currentIndex === 0 ? navLinks.length - 1 : currentIndex - 1;
                navLinks[prevIndex].focus();
                break;
        }
    });
}